<template>
  <a-card :bordered="false">
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit" :countries="countries"></list>
    <edit v-if="!showList" :record="record" @onGoBack="handleGoBack" :countries="countries"></edit>
  </a-card>
</template>

<script>

import CountryApi from '@/api/basicdata/api-country'
// 动态切换组件
import List from './StateList'
import Edit from './StateEdit'

export default {
  name: 'StatePage',
  components: {
    List,
    Edit
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true,
      // 国家信息列表
      countries: []
    }
  },
  mounted () {
    this.initLoad()
  },
  methods: {
    // 加载初始数据
    async initLoad () {
      const res = await CountryApi.list()
      this.countries = res.data
    },
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
